import { QueryClientProvider } from '@tanstack/react-query'
import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { I18nProvider } from '../lib/i18n'
import { queryClient } from '../lib/query-client'

/**
 * The root route. Wraps the whole app in the TanStack Query provider and the
 * i18n provider. The cockpit shell mounts under `_authed`; `_auth` (login /
 * signup) renders without the shell. Theme is applied to `<html>` by
 * `lib/theme.ts` (set pre-paint in index.html), so no theme wrapper div is
 * needed here.
 */
export interface RootContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RootContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <Outlet />
      </I18nProvider>
    </QueryClientProvider>
  )
}
